@if (inputService.show) {
  <ng-container [formGroup]="inputService.formGroup">
    <mat-form-field [appearance]='inputService.inputConfig.appearence' class="dataset-select-form-field">
      <mat-label>
        @if (inputService.exportEAgency) {
          <img matTooltip='Esportato in eAgency' class='title-input-eagency' src='assets/images/logos/logo_eagency.png'/>
        }
        @if (inputService.formInputDefinition.titleIcon) {
          <mat-icon class='title-input-icon' [matTooltip]='inputService.formInputDefinition.titleTooltip'>{{inputService.formInputDefinition.titleIcon}}</mat-icon>
        }
        <span>{{inputService.computedTitle | translate}}</span>
      </mat-label>
      @if (inputService.inputConfig.readOnly) {
        <input matInput readonly [required]='inputService.inputConfig.required' [value]='selectedItem ? selectedItem.label : ""' />
      }
      @if (!inputService.inputConfig.readOnly) {
        <mat-select [required]='inputService.inputConfig.required' [placeholder]="inputService.inputConfig.placeholder" [formControlName]='inputService.formControlKey' (selectionChange)="selectionChange($event)">
          <input class="myInput"
            matInput
            selectPanelSearch
            type="text"
            (input)="search($event.target.value)"
            autocomplete="off"
            [placeholder]="'Cerca' | translate">
          @if (loading) {
            <mat-progress-bar mode='indeterminate' ></mat-progress-bar>
          }
          <mat-divider></mat-divider>
          @for (selectOption of filteredSelectOptions; track selectOption) {
            <mat-option [value]='selectOption.value'>
              @if (inputService.formInputDefinition.extra.icon) {
                <mat-icon>{{inputService.formInputDefinition.extra.icon}}</mat-icon>
              }
              <span [innerHTML]='selectOption.label'></span>
            </mat-option>
          }
        </mat-select>
      }
      @if (loading) {
        <mat-spinner diameter="20" matSuffix></mat-spinner>
      }
      <!-- MDC: matSuffix deve stare sull'elemento proiettato di primo livello, non
      dentro un <div> wrapper (altrimenti finisce nell'infix, X a capo). -->
      @if (!loading && inputService.control.value && !inputService.inputConfig.readOnly) {
        <span class="close-icon material-icons" matIconSuffix style='cursor: pointer;' (click)='clear()'>close</span>
      }
      <!-- mat-hint here generate an error, need to investigate -->
      <!--<mat-hint *ngIf='inputService.inputConfig.hint'>{{inputService.inputConfig.hint}}</mat-hint>-->
      @if (!inputService.control.valid && inputService.errorMessage) {
        <mat-error>{{inputService.errorMessage | translate}}</mat-error>
      }
    </mat-form-field>
  </ng-container>
}